/* eslint-disable import/no-duplicates */
import ru from "date-fns/locale/ru"
import format from "date-fns/format"
import formatInTimeZone from "date-fns-tz/formatInTimeZone"
import getTimezoneOffset from "date-fns-tz/getTimezoneOffset"
/* eslint-enable import/no-duplicates */

export const DEFAULT_LOCALE = "ru"
export const DEFAULT_TZ = "Europe/Moscow"
export const DEFAULT_TZ_OFFSET_MS = getTimezoneOffset(DEFAULT_TZ)
export const getLocalTzOffsetMs = () =>
  new Date().getTimezoneOffset() * 60 * 1000

export function formatDate (
  utcTs: number,
  pattern: string,
  locale = DEFAULT_LOCALE,
  tz = DEFAULT_TZ,
): string {
  let locale_
  if (locale === "ru") locale_ = ru

  return tz
    ? formatInTimeZone(utcTs, tz, pattern, { locale: locale_ })
    : format(utcTs, pattern, { locale: locale_ })
}

export function getRange (
  start: number,
  finish: number,
  locale = DEFAULT_LOCALE,
  tz = DEFAULT_TZ,
) {
  const fmt = (t: number) => formatDate(t, "HH:mm", locale, tz)
  return `${fmt(start)} – ${fmt(finish)}`
}

export const DAY_MS = 24 * 60 * 60 * 1000

export const SERVER_TZ = "Europe/Moscow"
export const MFM_PROGRAM_TZ = "Asia/Yekaterinburg"
export const MFM_PROGRAM_TZ_SHIFT_MS =
  getTimezoneOffset(MFM_PROGRAM_TZ) - getTimezoneOffset(SERVER_TZ)

export const MFM_PROGRAM_TZ_LABEL =
  `GMT+${Math.round(getTimezoneOffset(MFM_PROGRAM_TZ) / (60 * 60 * 1000))}`

export function toMfmProgramTs (ts: number): number {
  return ts ? ts - MFM_PROGRAM_TZ_SHIFT_MS : 0
}

export function mfmProgramNow (): number {
  return Date.now() + MFM_PROGRAM_TZ_SHIFT_MS
}

export function timeOfDay (timeTs: number, anchorTs: number): number {
  return (((timeTs - anchorTs) % DAY_MS) + DAY_MS) % DAY_MS
}

export function alignToToday (anchorTs: number): number {
  return anchorTs + Math.floor((mfmProgramNow() - anchorTs) / DAY_MS) * DAY_MS
}

export function combineDateTime (
  dateTs: number,
  timeTs: Nullable<number>,
  anchorTs: number,
): number {
  if (!dateTs) return 0

  return dateTs + (timeTs ? timeOfDay(timeTs, anchorTs) : 0)
}

export function toCountdownParts (
  ms: number,
): { days: number; time: string } {
  const total = Math.max(0, Math.floor(ms / 1000))
  const pad = (value: number) => String(value).padStart(2, "0")

  return {
    days: Math.floor(total / (DAY_MS / 1000)),
    time: [
      Math.floor(total / 3600) % 24, Math.floor(total / 60) % 60, total % 60,
    ].map(pad).join(":"),
  }
}

export function cutSeconds (time: string): string {
  return time.split(":").slice(0, 2).join(":")
}

export function timeToMs (time: string | undefined): number {
  if (!time) return 0

  const [hoursStr, minutesStr, secondsStr = "0"] = time.split(":")
  const hours = Number.parseInt(hoursStr)
  const minutes = Number.parseInt(minutesStr)
  const seconds = Number.parseInt(secondsStr)

  if ([hours, minutes, seconds].some(Number.isNaN)) return 0

  return (hours * 60 * 60 * 1000) + (minutes * 60 * 1000) + (seconds * 1000)
}
